/* eslint-disable semi */
import localforage from 'localforage';
import { applyMiddleware, compose, createStore, combineReducers } from 'redux';
import { createInjectorsEnhancer } from 'redux-injectors';
import { persistReducer, persistStore } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import createSagaMiddleware from 'redux-saga';
import rootReducer, { reducers } from '../reducers';
import mainSaga from '../sagas';
import { env } from '@src/env';

const sagaMiddleware = createSagaMiddleware();
const persistConfig = {
  key: 'root',
  storage: localforage,
  stateReconciler: autoMergeLevel2,
  blacklist: [
    'auth',
    'entities',
    'workplans',
    'routes',
    'locations',
    'drivers',
    'geofences',
    'jobsBacklog',
    'groups',
    'jobsBoard',
    'jobsReport',
    'units'
  ],
  //auth is a nested blacklist, check auth reducer for blacklist details
  //blacklist no guarda
  //whitelist sí guarda
  // There is an issue in the source code of redux-persist (default setTimeout does not cleaning)
  timeout: null
};

const baseReducer = combineReducers(reducers);
const persistedReducer = persistReducer(persistConfig, (state, action) =>
  rootReducer(state, action, baseReducer)
);

let composeEnhancers = compose;

if (env.DEV) {
  composeEnhancers =
    (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        trace: true,
        traceLimit: 15
      })) ||
    compose;
}

const runSaga = sagaMiddleware.run;
const injectEnhancer = createInjectorsEnhancer({
  createReducer: (injectedReducers = {}) => {
    const combined = combineReducers({
      ...reducers,
      ...injectedReducers
    });
    return (state, action) => rootReducer(state, action, combined);
  },
  runSaga
});

const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware), injectEnhancer)
);

const persistor = persistStore(store);

sagaMiddleware.run(mainSaga);

export { persistor, store };
